module.exports = __webpack_public_path__ + "media/images/flags/16/Kenya-2442a8b521c3fbc3a3a4286ff4ae7b51.png";